import type { Phrases } from '../common/Phrases.d';
// import type { ButtonGroupOption } from '../../../components/react-hook-form/ButtonGroup';


import React, { useMemo } from 'react';
// import { Span } from '../../../components/Element';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import {
	type ButtonRadioGroupOption,
	ButtonRadioGroup } from '../../../components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	SERVICES_FIELD_NAME,
	FIELD_VALUE_WHO,
} from './constants';

export const WhoButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const groupLabel = phrases['notificationForm.services.whoField.label'];
	const municipalServicesLabel = phrases['notificationForm.services.whoField.value.municipalServices'];

	const WHO_OPTIONS: ButtonRadioGroupOption[] = useMemo(() => [{
		value: FIELD_VALUE_WHO.MUNICIPAL_SERVICES,
		label: municipalServicesLabel,
		// TODO? ariaLabel: `Sett ${groupLabel} til ${municipalServicesLabel}`,
	},{
		value: FIELD_VALUE_WHO.SPECIALIST_HEALTH_SERVICES,
		label: phrases['notificationForm.services.whoField.value.specialistHealthServices'],
	},{
		value: FIELD_VALUE_WHO.EMERGENCY_SERVICES,
		label: phrases['notificationForm.services.whoField.value.emergencyServices'],
	},{
		value: FIELD_VALUE_WHO.TEST_ANALYSIS_OR_LABORATORY,
		label: phrases['notificationForm.services.whoField.value.testAnalysisOrLaboratory'],
	},{
		value: FIELD_VALUE_WHO.NON_PROFIT_OR_VOLUNTARY_ACTOR,
		label: phrases['notificationForm.services.whoField.value.nonProfitOrVoluntaryActor'],
	}], [phrases]);

	return (
		<ButtonRadioGroup
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			errorSummaryLabel={groupLabel}
			label={groupLabel}
			name={SERVICES_FIELD_NAME.WHO}
			options={WHO_OPTIONS}
		/>
	);
};
